$(function(){

    var totalPrice = 0;
    var hasDiscounts = false;

    $('.j-o-product').each(function(){

        var price 		= $(this).data('price');
        var discount 	= $(this).data('discount');

        if ( discount != 0 ){

            // console.log('REACHED');
            var hasDiscounts = true;

            var discountedPrice = price - (price * (discount / 100));
            var discountedPriceValue = ( discountedPrice / 100 );

            // console.log('Discounted price: ' + discountedPriceValue);
            $(this).data('price', discountedPriceValue);

            totalPrice += Number(discountedPriceValue);

        } else {

            product_price = price / 100;
            $(this).data('price', product_price);
            totalPrice += Number(product_price);

        }

        // console.log('Looped totals: ' + totalPrice);

        // I need to create a variable where all the 'prices' are added up

    });


    $('.j-item-totals').data('currentprice', totalPrice);
    $('.j-item-totals').text('£' + totalPrice.toFixed(2));
    console.log('TOTALS: ' + totalPrice);


    $(document).on('click', '.add-to-cart-optimise', function(e){

        e.preventDefault();

        $('.j-o-product.active').each(function(){

            var id = 		$(this).data('pid');
            var quantity = 	1;

            console.log(id);
            console.log(quantity);

            CartJS.addItem(id, quantity, {}, {
                "success": function(data, textStatus, jqXHR) {

                    if ( !$('.add-to-cart-optimise').hasClass('trade-button') ){

                        $('.j-toggle-cart').addClass('active');
                        $('.cart-sidebar').addClass('active');
                        $('.site-header').addClass('cart-active');

                    } else {

                        var url = window.location.href + '?cart=open';

                        setTimeout(function(){
                            window.location.replace(url);
                        }, 1000);

                    }

                },
                "error": function(jqXHR, textStatus, errorThrown) {
                    console.log('Error: ' + errorThrown + '!');
                }
            });

        });

    });

});